'use client';

import { Button } from '@/components/ui/button';
import { usePrivyLogin } from '@/hooks/usePrivyLogin';
import { useTranslation } from 'react-i18next';

/**
 * Privy 登录按钮
 *
 * 功能：
 * - 提供 Google 社交登录
 * - 登录成功后自动调用后端 API
 * - 显示登录中状态
 * - 样式与 WalletConnectBtn 保持一致
 */
export function PrivyLoginButton({ 
  className, 
  onLoginSuccess 
}: { 
  className?: string; 
  onLoginSuccess?: () => void 
}) {
  const { t } = useTranslation();
  const { login, isProcessing } = usePrivyLogin(onLoginSuccess);
  return (
    <Button
      onClick={() => {
        login();
      }}
      size="sm"
      className={`min-w-[150px] ${className}`}
    >
      {isProcessing ? t('action.loggingIn') : t('action.login')}
    </Button>
  );
}
